export const firebaseConfig = {
  apiKey: 'AIzaSyCiZVRwVLWDv2u8S98TW_UUz82GHwFZXIA',
  authDomain: 'yoloworks-vcc-prod.firebaseapp.com',
  projectId: 'yoloworks-vcc-prod',
  storageBucket: 'yoloworks-vcc-prod.appspot.com',
  messagingSenderId: '829055167544',
  appId: '1:829055167544:web:bc1306e85a951b52e7cacd',
};
